import { useApplicationContext } from '~/shared/context/use-application-context';

import type { JobItemDetails } from '../../api/use-job-item-details';

type ReviewerDisplay = {
    readonly displayName: string;
    readonly hasReviewer: boolean;
    readonly isReviewerCurrentUser: boolean;
    readonly contextLine: string;
};

export const useReviewerDisplay = (item: Pick<JobItemDetails, 'reviewer'>): ReviewerDisplay => {
    const { applicationState } = useApplicationContext();
    const currentUserId = applicationState.myUserProfile.get('id').unwrapOr('');
    const currentFirstName = applicationState.myUserProfile.get('firstName').unwrapOr('');
    const currentLastName = applicationState.myUserProfile.get('lastName').unwrapOr('');

    const displayName = [item.reviewer?.firstName, item.reviewer?.lastName]
        .filter((value): value is string => value != null && value.trim().length > 0)
        .join(' ')
        .trim();
    const reviewerId = item.reviewer?.id ?? '';

    const isReviewerCurrentUser =
        reviewerId.length > 0 && currentUserId.length > 0
            ? reviewerId === currentUserId
            : displayName.length > 0 &&
              displayName.toLowerCase() ===
                  [currentFirstName, currentLastName]
                      .map((part) => part.trim())
                      .filter((part) => part.length > 0)
                      .join(' ')
                      .toLowerCase();

    const hasReviewer = displayName.length > 0;

    const contextLine = hasReviewer ? (isReviewerCurrentUser ? 'You' : displayName) : 'Not assigned';

    return { contextLine, displayName, hasReviewer, isReviewerCurrentUser };
};
